(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deqoria-remodeling-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dq-remodeling-compare')) {
    customElements.define('dq-remodeling-compare', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const input = this.querySelector('input[type="range"]');
        if (!input) return;
        const update = () => this.style.setProperty('--dq-position', input.value + '%');
        const move = event => {
          const rect = this.getBoundingClientRect();
          if (!rect.width) return;
          input.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))));
          update();
        };
        let pointerId = null;
        this.addEventListener('pointerdown', event => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          pointerId = event.pointerId;
          this.setPointerCapture(pointerId);
          input.focus({ preventScroll: true });
          move(event);
        }, { signal });
        this.addEventListener('pointermove', event => { if (event.pointerId === pointerId) move(event); }, { signal });
        const finish = () => { pointerId = null; };
        this.addEventListener('pointerup', finish, { signal });
        this.addEventListener('pointercancel', finish, { signal });
        this.addEventListener('lostpointercapture', finish, { signal });
        input.addEventListener('input', update, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deqoria-terrazzo-landing"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dq-terrazzo-compare')){
 customElements.define('dq-terrazzo-compare',class extends HTMLElement{
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;const input=this.querySelector('input[type="range"]');if(!input)return;const update=()=>this.style.setProperty('--dq-tz-position',input.value+'%');const move=e=>{const r=this.getBoundingClientRect();if(!r.width)return;input.value=String(Math.round(Math.max(0,Math.min(100,(e.clientX-r.left)/r.width*100))));update()};let pointerId=null;this.addEventListener('pointerdown',e=>{if(!e.isPrimary||(e.pointerType==='mouse'&&e.button!==0))return;pointerId=e.pointerId;this.setPointerCapture(pointerId);input.focus({preventScroll:true});move(e)},{signal});this.addEventListener('pointermove',e=>{if(e.pointerId===pointerId)move(e)},{signal});const finish=()=>{pointerId=null};this.addEventListener('pointerup',finish,{signal});this.addEventListener('pointercancel',finish,{signal});this.addEventListener('lostpointercapture',finish,{signal});input.addEventListener('input',update,{signal});update()}
  disconnectedCallback(){this.controller?.abort()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
